//ページ内リンク
jQuery(window).on('load', function() {
  let headerHeight = $('header').outerHeight();
  let urlHash = location.hash;
  if (urlHash) {
    let position = $(urlHash).offset().top - headerHeight;
    $('html, body').animate({ scrollTop: position }, 0);
  }
});

jQuery(function ($) {

  //copyright年更新
  document.getElementById("current-year").innerText = new Date().getFullYear();

  $(document).ready(function(){
    $('.fv-txt__shoulder').addClass('is-shown');
    $('.fv-txt__main').addClass('is-shown');
    $('.fv-img__item').addClass('is-active');
  });

  //ページ内リンク
  $('.js-anchor').on('click', function () {
    let time = 400;
    let header = $('header').height();
    let target = $(this.hash);
    if (!target.length) return;
    let targetY = target.offset().top - header;
    $('html,body').animate({
      scrollTop: targetY
    }, time, 'swing');
    return false;
  });

  //ハンバーガーメニュー
  $('.header-hamburger, .nav-bg').on('click', function () {
    // $('.nav-bg').css('height',$(window).height());
    $('body').toggleClass('is-fixed');
    $('.header-hamburger').toggleClass('is-active');
    $('.header-nav').toggleClass('is-active');
    $('header').toggleClass('is-active');
    $('.nav-bg').toggleClass('is-active');
  });

  $('.header-nav__list a').on('click', function () {
    // $('.nav-bg').css('height',auto);
    $('body').removeClass('is-fixed');
    $('.header-hamburger').removeClass('is-active');
    $('.header-nav').removeClass('is-active');
    $('header').removeClass('is-active');
    $('.nav-bg').removeClass('is-active');
  });

  // $(window).on('scroll', function () {
  //   hsize = $(window).height();　//window高さをセット
  //   $(".menu").css("height", hsize);
  // });

  //フォーム
  $(".form-item__input").each(function() {
    if ($(this).find("span.error").length == 1) {
      $(this).addClass("is-error");
    }
  });

  $('#corporate .fv-img').slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 25000,
    cssEase: "linear",
    slidesToShow: 1,
    swipe: false,
    arrows: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    infinite: true,
    // variableWidth: false,
    adaptiveHeight: true,
    centerMode: true,
    centerPadding: "30%",
    responsive: [{
      breakpoint: 600,
      settings: {
        centerPadding: "10%"
      }
    }, {
      breakpoint: 300,
      settings: "unslick" // slickを削除
    }]
  });

  //トップへ戻る
  // var pagetop = $('.footer-content__top')
  // pagetop.click(function () {
  //   $('body, html').animate({
  //     scrollTop: 0
  //   }, 500);
  //   return false;
  // });

  // $('.js-accordion__content').hide();
    $('.js-accordion__btn').on('click', function(){
      $(this).toggleClass('is-open');
      $(this).next('.js-accordion__content').slideToggle();
    });

  //コンテンツフェードイン
  $(window).on('scroll', function () {
    $('.js-anim').each(function () {
      var elemPos = $(this).offset().top,
        scroll = $(window).scrollTop(),
        windowHeight = $(window).height();
      if (scroll > elemPos - windowHeight) {
        $(this).addClass('is-anim');
      }
    });
    // $('.js-fadein_slow').each(function () {
    //   var elemPos = $(this).offset().top,
    //     scroll = $(window).scrollTop(),
    //     windowHeight = $(window).height();
    //   if (scroll > elemPos - windowHeight + 100) {
    //     $(this).delay(500).queue(function () {
    //       $(this).addClass('fadein').dequeue();
    //     });
    //   }
    // });
  });

  //MW WP FORM スクロール位置調整
  // if ($('.error')[0]) {
  //   $('.mw_wp_form').addClass('mw_wp_form_error');
  //   var errorEl = $('.mw_wp_form').eq(0);
  //   var position = errorEl.parent().offset().top - 85;
  //   $('body,html').delay(200).animate({
  //     scrollTop: position
  //   }, 600, 'linear');
  // }
});